import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,0 C1489.35529,0 1920,430.644706 1920,960 C1920,1489.35529 1489.35529,1920 960,1920 C430.644706,1920 0,1489.35529 0,960 C0,674.710588 127.058824,407.378824 342.889412,225.882353 L342.889412,225.882353 L0,225.882353 L0,112.941176 L564.705882,112.941176 L564.705882,677.647059 L451.764706,677.647059 L451.764706,284.272941 C239.548235,444.084706 112.941176,692.894118 112.941176,960 C112.941176,1427.12471 492.875294,1807.05882 960,1807.05882 C1427.12471,1807.05882 1807.05882,1427.12471 1807.05882,960 C1807.05882,492.875294 1427.12471,112.941176 960,112.941176 L960,112.941176 Z M1202.42824,694.192941 L1282.27765,774.042353 L1039.90588,1016.41412 L1282.27765,1258.89882 L1202.42824,1338.74824 L959.943529,1096.37647 L717.571765,1338.74824 L637.722353,1258.89882 L880.094118,1016.41412 L637.722353,774.042353 L717.571765,694.192941 L959.943529,936.564706 L1202.42824,694.192941 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSisNotSyncedLine = /*#__PURE__*/function (_Component) {
  _inherits(IconSisNotSyncedLine, _Component);

  var _super = _createSuper(IconSisNotSyncedLine);

  function IconSisNotSyncedLine() {
    _classCallCheck(this, IconSisNotSyncedLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconSisNotSyncedLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSisNotSynced",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSisNotSyncedLine.displayName = "IconSisNotSyncedLine";
  return IconSisNotSyncedLine;
}(Component);

IconSisNotSyncedLine.glyphName = 'sis-not-synced';
IconSisNotSyncedLine.variant = 'Line';
IconSisNotSyncedLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSisNotSyncedLine;
export { IconSisNotSyncedLine };